const Name = ({ text, className }) => {
  return (
    <span className={`custom-underline relative uppercase ${className}`}>
      {text}
    </span>
  )
}

export default Name
